import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useTranslation } from "context/TranslationProvider";

const NotificationTemplatePreviewModal = ({ isOpen, toggle, htmlContent }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      className="email-preview-modal custom-modal"
    >
      <ModalHeader toggle={toggle} className="custom-modal-header">
        {t("page.notificationTemplates.previewTitle", "Template Preview")}
      </ModalHeader>

      <ModalBody className="custom-modal-body">
        {htmlContent ? (
          <iframe
            title="Email Preview"
            className="email-preview-frame"
            sandbox=""
            srcDoc={`<!DOCTYPE html>
            <html>
              <head>
                <meta charset="UTF-8">
                <style>
                  body{
                    margin:0;
                    padding:20px;
                    font-family: Arial, Helvetica, sans-serif;
                    background:#f8f9fa;
                  }

                  a{
                    pointer-events:none !important;
                    cursor:default !important;
                  }

                  img{
                    max-width:100%;
                    height:auto;
                  }
                </style>
              </head>
              <body>
                ${htmlContent}
              </body>
            </html>`}
          />
        ) : (
          <div className="loading-text">{t("common.loading", "Loading....")}</div>
        )}
      </ModalBody>

      <ModalFooter className="custom-modal-footer">
        <Button color="secondary" onClick={toggle}>
          {t("button.close", "Close")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default NotificationTemplatePreviewModal;